<template>
  <a-modal :visible="visible" :title="title" @cancel="close" @ok="ok" :ok-text="$t('common.okText')" :cancel-text="$t('common.cancelText')" :width="1200">
    <a-form-model>
      <a-form-model-item :key="index" v-for="(item, index) in rules">
        <a-row :gutter="16">
          <a-col v-for="formItem in form" :key="formItem.dataIndex" :span="formItem.span">
            <a-select v-if="formItem.type === 'select'" v-model="item[formItem.dataIndex]" :placeholder="formItem.placeholder">
              <a-select-option v-for="(value, key) in formItem.options" :key="key" :value="key">{{ value }}</a-select-option>
            </a-select>
            <a-input v-if="formItem.type === 'text'" v-model="item[formItem.dataIndex]" :placeholder="formItem.placeholder" />
          </a-col>
          <a-col :span="2">
            <a-icon
              style="cursor: pointer;position: relative;top: 4px;font-size: 24px;color: #999;transition: all 0.3s;"
              type="minus-circle-o"
              @click="removeRule(index)"/>
          </a-col>
        </a-row>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="dashed" block @click="addRule">
          <a-icon type="plus" />{{ $t('buttons.add') }}
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'ConvertModal',
  model: {
    prop: 'record',
    event: 'change'
  },
  props: {
    visible: Boolean,
    title: String,
    record: {
      type: Object,
      default: () => {}
    },
    form: Array,
    field: String
  },
  data () {
    return {
      rules: []
    }
  },
  watch: {
    visible (val, oldVal) {
      console.log(this.form);
      if (val && this.record[this.field]) {
        this.rules = this.record[this.field]
      } else {
        this.rules = []
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    ok () {
      this.record[this.field] = this.rules
      this.$emit('close')
    },
    addRule () {
      const o = {}
      for (let i = 0; i < this.form.length; i++) {
        console.log(this.form);
        if (this.form[i].type === 'select') {
          o[this.form[i].dataIndex] = 'EQ'
        } else {
          o[this.form[i].dataIndex] = ''
        }
      }
      this.rules.push(o)
    },
    removeRule (index) {
      this.rules.splice(index, 1)
    }
  }
}
</script>

<style scoped>

</style>
